import { render } from "./App.vue?vue&type=template&id=298d156a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=298d156a&lang=css"
script.render = render

export default script